var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisabledNewTab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1420",
    stroke: "#acacac",
    "data-name": "Group 1420",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15.198,
    height: 15.198,
    viewBox: "0 0 15.198 15.198",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1152",
    "data-name": "Rectangle 1152",
    width: 15.198,
    height: 15.198,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1416",
    "data-name": "Group 1416",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25636",
    "data-name": "Path 25636",
    d: "M13.6,37.2v7.567a.9.9,0,0,1-.9.9H.9a.9.9,0,0,1-.9-.9v-11.8a.9.9,0,0,1,.9-.9H8.464a.523.523,0,0,1,0,1.047H1.246a.2.2,0,0,0-.2.2V44.417a.2.2,0,0,0,.2.2H12.353a.2.2,0,0,0,.2-.2V37.2a.523.523,0,0,1,1.047,0",
    transform: "translate(0 -30.465)",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25637",
    "data-name": "Path 25637",
    d: "M141.866.51V3.738a.51.51,0,0,1-.51.51h-.027a.51.51,0,0,1-.51-.51V1.882a.04.04,0,0,0-.068-.028L134.22,8.386a.535.535,0,0,1-.727.036.523.523,0,0,1-.025-.764l6.545-6.545a.04.04,0,0,0-.028-.068h-1.856a.51.51,0,0,1-.51-.51V.51a.51.51,0,0,1,.51-.51h3.228a.51.51,0,0,1,.51.51",
    transform: "translate(-126.668)",
    fill: "#454545"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledNewTab);
export default __webpack_public_path__ + "static/media/disabledNewTab.4dea4e95fef656eaec2c58cf3f604136.svg";
export { ForwardRef as ReactComponent };